var map = {
	"./1.svg": "3e23",
	"./2.svg": "89b4",
	"./3.svg": "1550",
	"./4.svg": "4d8e",
	"./5.svg": "05a5",
	"./6.svg": "ec31",
	"./7.svg": "4161",
	"./8.svg": "e048",
	"./9.svg": "c710",
	"./beboss.svg": "acda",
	"./facebook.svg": "aaa3",
	"./forbes.svg": "1888",
	"./icon-1.svg": "1c94",
	"./icon-10.svg": "fefe",
	"./icon-11.svg": "34f5",
	"./icon-12.svg": "26a7",
	"./icon-13.svg": "9134",
	"./icon-14.svg": "8775",
	"./icon-15.svg": "060f",
	"./icon-16.svg": "6e35",
	"./icon-17.svg": "971d",
	"./icon-18.svg": "256e",
	"./icon-19.svg": "94a0",
	"./icon-2.svg": "f18c",
	"./icon-20.svg": "b29f",
	"./icon-21.svg": "ae80",
	"./icon-3.svg": "dc41",
	"./icon-4.svg": "265f",
	"./icon-5.svg": "7806",
	"./icon-6.svg": "6b49",
	"./icon-7.svg": "8d36",
	"./icon-8.svg": "fb89",
	"./icon-9.svg": "b9c6",
	"./instagram.svg": "54e6",
	"./snowflake-1.svg": "58d9",
	"./snowflake-2.svg": "6182",
	"./snowflake-3.svg": "a46d",
	"./snowflake-4.svg": "9f1b",
	"./snowflake-5.svg": "1d08",
	"./telegram.svg": "7dd3",
	"./viber.svg": "962c",
	"./vk.svg": "330c",
	"./well-full.svg": "1aaf",
	"./well-marker.svg": "7c2b",
	"./well-small.svg": "e352",
	"./whatsapp.svg": "3357"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";